import { throwError as observableThrowError, Observable, BehaviorSubject } from 'rxjs';
import { take, filter, catchError, switchMap, finalize, map, tap, first } from 'rxjs/operators';
import { Injectable, Injector } from "@angular/core";
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from "@angular/common/http";

import { AuthService } from '../services/auth.service'
import { HttpService } from './http.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalInterceptor implements HttpInterceptor {

    isRefreshingToken: boolean = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(
        private router: Router,
        private authService: AuthService,
        private injector: Injector,
        private httpService: HttpService
    ) { }

    addToken(req: HttpRequest<any>): HttpRequest<any> {

        if (req.url.endsWith('oauth/token')) {
            return req;
        } else {
            let token = this.authService.getToken();
            if (token) {
                return req.clone({ setHeaders: { Authorization: 'Bearer ' + token.access_token } });
            } else {
                return req;
            }

        }
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        return next.handle(this.addToken(req)).pipe((ob) => {
            this.httpService.addRequestCnt();
            return ob;
        }).pipe(
            catchError(error => {
                //console.log("globalinterceptor error", error)
                if (error instanceof HttpErrorResponse) {
                    switch ((<HttpErrorResponse>error).status) {
                        case 400:
                            return this.handle400Error(error);
                        case 401:
                            return this.handle401Error(error, req, next);

                        default:
                            return this.handleError(error);
                    }
                } else {
                    return observableThrowError(error);
                }
            }), finalize(() => {
                this.httpService.subtractRequestCnt();
            }));
    }

    handleError(error) {
        /*
        if (error instanceof HttpErrorResponse) {
            console.error('navigator.onLine', navigator.onLine);
            console.log(`status: ${error.status}, ${error.statusText}`);
        }
        */
        return observableThrowError(error);
    }

    handle400Error(error) {
        if (error && error.status === 400 && error.error && error.error.error === 'invalid_grant') {
            this.authService.removeToken();
        }

        return observableThrowError(error);
    }

    handle401Error(error, req: HttpRequest<any>, next: HttpHandler) {

        if(error.status == 401 && error.url.endsWith('/oauth/token')){

            return this.logoutUser();
        }
        
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;

            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            return this.authService.refreshToken().pipe(
                switchMap((newToken: any) => {

                    if (newToken) {
                        this.authService.saveToken(newToken);
                        this.tokenSubject.next(newToken);
                        return next.handle(this.addToken(req));
                    }

                    // If we don't get a new token, we are in trouble so logout.
                    return this.logoutUser();
                }),
                catchError(error => {
                    // If there is an exception calling 'refreshToken', bad news so logout.
                    return this.logoutUser();
                }),
                finalize(() => {
                    this.isRefreshingToken = false;
                }));
              
        } else {

            return this.tokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(jwt => {
                    return next.handle(this.addToken(req));
                }));
        }
    }

    logoutUser() {
        this.authService.removeToken();
        this.router.navigate(["/sign/sign-in"]);
        // Route to the login page (implementation up to you)
        return observableThrowError("");
    }

}
